import React, { useState, useEffect } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import { GetApp as InstallIcon, Smartphone as PhoneIcon } from '@mui/icons-material';

const SimplePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [showMobileHint, setShowMobileHint] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if PWA is enabled via environment variable
  const isPWAEnabled = process.env.REACT_APP_ENABLE_PWA === 'true';

  useEffect(() => {
    // Don't initialize PWA install functionality if PWA is disabled
    if (!isPWAEnabled) {
      return;
    }

    // PWA install prompts are disabled - prevent beforeinstallprompt from showing banners
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent the install banner from showing
      setDeferredPrompt(e); // Store the event but don't show UI
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [isPWAEnabled]);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log('Install prompt result:', outcome);
      setDeferredPrompt(null);
      setShowInstall(false);
    }
  };

  const getMobileInstallMessage = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
      return 'To install: Tap Share button → Add to Home Screen';
    } else if (userAgent.includes('android')) {
      return 'To install: Tap menu (⋮) → Add to Home screen';
    }
    return 'Install this app for a better experience!';
  };

  // Don't render anything if PWA is disabled
  if (!isPWAEnabled) {
    return null;
  }

  // PWA install prompts disabled - keeping PWA functionality but hiding install UI
  return null;
  
  /*
  // DISABLED PWA INSTALL PROMPTS - Uncomment below to re-enable
  return (
    <>
      {showInstall && (
        <Button
          variant="contained"
          startIcon={<InstallIcon />}
          onClick={handleInstall}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          Install App
        </Button>
      )}

      <Snackbar
        open={showMobileHint}
        autoHideDuration={8000}
        onClose={() => setShowMobileHint(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setShowMobileHint(false)}
          severity="info"
          variant="filled"
          icon={<PhoneIcon />}
          sx={{ width: '100%' }}
        >
          {getMobileInstallMessage()}
        </Alert>
      </Snackbar>
    </>
  );
  */
};

export default SimplePWAInstall;
